import { render, staticRenderFns } from "./ChangeFlightPage.vue?vue&type=template&id=027f2965&scoped=true&"
import script from "./ChangeFlightPage.vue?vue&type=script&lang=js&"
export * from "./ChangeFlightPage.vue?vue&type=script&lang=js&"
import style0 from "./ChangeFlightPage.vue?vue&type=style&index=0&id=027f2965&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f2965",
  null
  
)

export default component.exports